module.exports = __webpack_public_path__ + "static/mielikki-symbol-SCAG-ae191245407b0a90d8ba3ec74cd0085e.png";